import { useNavigate } from "react-router-dom";
import { AvisDirection, INavigationLink } from "../../../../models";
import { AvisNavigationItem } from "./navigationBlock/AvisFormNavigationItem";
import { AvisUtils } from "../../../../utils";

interface IAvisBackProps {
  backLink?: INavigationLink;
}
export function AvisBack(props: Readonly<IAvisBackProps>) {
  const { backLink } = props;
  const navigate = useNavigate();

  const handleClick = () => {
    if (backLink?.forceNavigateToUrlParams) {
      const queryParams = new URLSearchParams(location.search);
      const foundForceParams = backLink.forceNavigateToUrlParams.filter(
        (item) => queryParams.get(item) != null,
      );

      //If querystring contains 'force' param then redirect to defined url
      if (foundForceParams.length > 0) return false;
    }
    const canGoBack = AvisUtils.canGoHistoryBack();
    if (canGoBack) {
      navigate(-1);
      return true;
    }
    return false;
  };

  if (!backLink?.title) return;

  return (
    <AvisNavigationItem
      navLink={{ ...backLink, onClick: handleClick }}
      icon={{ className: "fa-chevron-left", location: AvisDirection.Left }}
    />
  );
}
